// extracted by css-extract-rspack-plugin
export default {"itemWrapper":"tv_lx","chevronDown":"fH9ud"};